import { axiosInstance as axios } from 'Api'
import { handlingResponse } from 'Utility/globalMethods'
import appEnvRemap from 'Utility/appEnvRemap'
if (process.env.ISMOCK === 'true') {
  try {
    require('Mocks/sca/sca')
  } catch (error) {
    console.error('Error loading info mock:', error)
  }
}

export async function generateOtp (params) {
  let data

  const { user, serviceId, servicePayload, additionalInfo } = params

  try {
    data = await axios({
      method: 'post',
      baseURL: appEnvRemap.API_REST_IAM,
      url: '/mfa/generate-otp',
      data: { user, serviceId, servicePayload },
      headers: {
        additionalInfo
      }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
export async function checkOtpAml (params) {
  let data

  try {
    data = await axios({
      method: 'post',
      url: '/services/merchant-service/public/aml/otp',
      data: { ...params }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}

export async function generateDoubleOtp (params) {
  let data
  const { user, serviceId, servicePayload, additionalInfo } = params

  try {
    data = await axios({
      method: 'post',
      url: '/services/mfa/generateOTPDouble',
      data: { user, serviceId, servicePayload },
      headers: {
        additionalInfo
      }
    })
    return handlingResponse(data)
  } catch (error) {
    return handlingResponse(error)
  }
}
// @generator api:method
